export default {"src":"/_next/static/media/ralston-logo.72df0807.svg","height":66,"width":288,"blurWidth":0,"blurHeight":0};